export enum FilterType {
  Slider = 'Slider',
  Options = 'Options',
}

export type ToggleSettingsString =
  | 'mf-aof'
  | 'mf-fs'
  | 'mf-ac'
  | 'mf-sc'
  | 'mf-amc'
  | 'mf-sopt'
  | 'mf-strat'
  | 'mf-bench'
  | 'mf-risk'
  | 'mf-tf'
  | 'mf-tax'
  | 'fd-tax'
  | 'fd-cat'
  | 'fd-bank'
  | 'fd-nbfc'
  | 'bonds-type'
  | 'bonds-reg'
  | 'pms-citem'
  | 'cash-type'
  | 're-type'
  | 'iequity-type'
  | 'pm-type'
  | 'de-type';

export interface Filter {
  title: String;
  toggleSettingsString: ToggleSettingsString;
  type: FilterType;
  field: String;

  options_key?: String;
  min_key?: String;
  max_key?: String;

  items_key?: String;
  selected_items_key?: String;
}

export enum MutualFundsFields {
  age = 'Age of the Fund',
  size = 'Fund Size (AUM in Crores)',
  class = 'Asset Class',
  scheme = 'Fund Category',
  amc = 'Fund House(AMC)',
  options = 'Suggested Options',
  strategy = 'Strategy',
  benchmark = 'Benchmark Index',
  risk = 'Risk Category',
  timeframe = 'Suggested Investment Time Frame(Years)',
  tax = 'Taxation Impact',
  returns = 'Expected Rate of Returns',
  name = 'Scheme Name',
  launchDate = 'Launch Date',
  exitLoad = 'Exit Load(Days)',
}

export enum CashFields {
  name = 'Name',
  type = 'Type',
}

export enum DirectEquityFields {
  name = 'Name',
  type = 'Type',
}

export enum PMSFields {
  name = 'Name',
}

export enum BondsFields {
  name = 'Bonds',
  type = 'Types of Bonds',
  roi = 'Interest rate',
  maturity = 'Maturity period',
  registrar = 'Registrar',
  price = 'Trading Price',
}

export enum FDFields {
  nbfc = 'NBFC',
  bank = 'Bank',
  category = 'Category',
  roi = 'Interest Rate',
  tax = 'Taxation',
  duration = 'Duration',
}

export enum PreciousMetalsFields {
  name = 'Name',
  type = 'Type',
}

export enum RealEstateFields {
  name = 'Name',
  type = 'Type',
}

export enum InternationalEquityFields {
  name = 'Name',
  type = 'Type',
}

export enum AssetPage {
  bonds = 'bonds',
  mf = 'mutual_funds',
  fd = 'fixed_deposit',
  cash = 'cash',
  re = 'real_estate',
  de = 'direct_equity',
  pms = 'portfolio_management_services',
  pm = 'precious_metals',
  iequity = 'international_equity',
  others = 'Others',
}



// WEBPACK FOOTER //
// ./src/app/modules/asset-selection/asset-catalog/types.ts